module.exports = __webpack_public_path__ + "img/logo-icoev-inicio.44c09154.png";